import styled from 'styled-components'

interface ContainerProps {
  isFilled: boolean
}

export const Container = styled.div<ContainerProps>`
  display: flex;
  align-items: center;
  margin-right: 5px;

  p,
  span {
    font-family: 'Inter';
    font-size: 0.875rem;
    color: ${props => props.theme.colors.color005597};
    font-weight: ${props => (props.isFilled ? 700 : 500)};
    line-height: 1rem;
    letter-spacing: 0px;
    white-space: pre-wrap;
    text-transform: capitalize;
  }

  span {
    margin-left: 5px;
  }
`
